import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { PillarsService } from 'src/app/features/pillars/stolbovi/service/pillars.service';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isSidebarOpen = false;
  data: any = null;
  isLoading = true;
  isMobile = false;

  constructor(
    public router: Router,
    private pillarsService: PillarsService,
    public authService: AuthService
  ) {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  ngOnInit(): void {
    this.userdata();
  }

  userdata() {
    this.pillarsService.userdata().subscribe({
      next: (data: any) => {
        this.data = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading user data:', err);
        this.isLoading = false;
        this.data = {
          firstName: 'Unknown',
          lastName: 'User',
          username: 'user@example.com'
        };
      }
    });
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }
  navigate(route: string): void {
    this.router.navigate([route]);
    this.closeSidebar();
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
    this.isSidebarOpen = false;
  }
}
